import "./DashboardPage.css";
import { lazy, Suspense } from "react";

import { CountProvider } from "../../context/CountContext.tsx";

import ReportCount from "../../components/Reportcount.tsx";
import DeferredRender from "../../components/DeferredRender.tsx";

const LiveViewWithCarousel = lazy(
  () => import("../../components/LiveViewSecWithCarousel.tsx"),
);

const ReportsInfiniteScrollUpdated = lazy(
  () => import("../../components/ReportsInfiniteScrollUpdated.tsx"),
);

const Alerts = lazy(() => import("../../components/Alerts.tsx"));

const CashierFraudUpdated = lazy(
  () => import("../../components/CashierFraudUpdated.tsx"),
);

const Iot = lazy(() => import("../../components/Iot.tsx"));

const Charts = lazy(() => import("../../components/Charts.tsx"));

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <CountProvider>
        <ReportCount />

        <DeferredRender delay={100}>
          <Suspense fallback={null}>
            <LiveViewWithCarousel />
          </Suspense>
        </DeferredRender>

        <DeferredRender delay={250}>
          <Suspense fallback={null}>
            <ReportsInfiniteScrollUpdated />
          </Suspense>
        </DeferredRender>

        <DeferredRender delay={400}>
          <Suspense fallback={null}>
            <Alerts />
          </Suspense>
        </DeferredRender>

        <DeferredRender delay={550}>
          <Suspense fallback={null}>
            <CashierFraudUpdated />
          </Suspense>
        </DeferredRender>

        <DeferredRender delay={700}>
          <Suspense fallback={null}>
            <Iot />
          </Suspense>
        </DeferredRender>

        <DeferredRender delay={850}>
          <Suspense fallback={null}>
            <Charts />
          </Suspense>
        </DeferredRender>
      </CountProvider>
    </div>
  );
};

export default Dashboard;
